/* eslint-disable @typescript-eslint/no-explicit-any */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * Creates an object from another with only the specified keys
 *
 * @aka onlyKeys
 * @since v2.22.0
 * @category Object
 * @template {T} - The type of the original object
 * @param {T} obj - The original object
 * @param {string[]} keys - The keys of the object to keep
 * @returns {*}
 * @example
 * const obj = { hello: 'world', hi: 'earth', hola: 'mundo' };
 * only(obj, ['hello', 'hola'])
 * //=> { hello: 'world', hola: 'mundo' }
 * @docgen_example
 * const obj = { hello: 'world', hi: 'earth', hola: 'mundo' };
 * only(obj, ['hello', 'hola']);
 */
export var only = function (obj, keys) {
    return keys && keys.reduce(function (output, key) {
        var _a;
        return (__assign(__assign({}, output), (_a = {}, _a[key] = obj[key], _a)));
    }, {}) || ({});
};
